module.exports = __webpack_public_path__ + "img/w12b.c10a1a9a.jpg";